import {Pattern, match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import type {AssistantBusinessCaseContext} from '@prompt-bridge/shared/ai-assistant-core';

import type {Nullish} from 'shared/web';

import {toBoundedAssistantBusinessCaseText} from './toBoundedAssistantBusinessCaseText';

export const toAssistantBusinessCaseSender = (
  displayName: string | Nullish,
  signatureQuery: {
    signatureCount: number | Nullish;
    isLoading: boolean;
    isError: boolean;
  }
): AssistantBusinessCaseContext['sender'] => {
  const boundedDisplayName = toBoundedAssistantBusinessCaseText(displayName);
  const hasSignature = match(signatureQuery)
    .with({isLoading: true}, () => true)
    .with({isError: true}, () => false)
    .with({signatureCount: Pattern.number}, ({signatureCount}) => signatureCount > 0)
    .otherwise(() => false);

  return {
    ...(isNotNil(boundedDisplayName) ? {displayName: boundedDisplayName} : {}),
    hasSignature,
  };
};
